module.exports = "<div class=\"sn-home\">\n  <div *ngIf=\"this.authService.isLoginByAuthToken\">\n    <div style=\"text-align: center;\">\n      <br />\n      <br />\n      <br />\n      <p class=\"loading\"><img src=\"assets/img/progress.gif\" /></p>\n  </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main